import { type QueryHookOptions, useQuery } from "@apollo/client";
import { StreamingUsageQuery } from "../graphql/queries";
import type {
  StreamingUsageQueryType,
  StreamingUsageQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useStreamingUsageQuery = (
  options?: QueryHookOptions<
    StreamingUsageQueryType,
    StreamingUsageQueryVariablesType
  >
) => {
  return useQuery<StreamingUsageQueryType, StreamingUsageQueryVariablesType>(
    StreamingUsageQuery,
    { fetchPolicy: "cache-and-network", ...options }
  );
};
